import axios from 'axios'
import URL from '../../../utils/urls'
import { AdfApplication } from '../adf-app-types'

/**
 * 
 * @returns a list of AdfApplications in the AdfApplication type
 */
export async function getAdfApps(): Promise<AdfApplication[]> {
    const results: any[] = await getAdfAppsRaw()

    let converted: AdfApplication[]
    try {
        converted = convertArrayToAdfApplications(results)
    } catch (error) {
        console.log('Error converting automated delivery of financial (ADF) data to type: ', error)
        return [];
    }

    return converted;
}


/**
 * 
 * @returns the "raw" ADF Application data from the data source.
 */
export async function getAdfAppsRaw(): Promise<any[]> {
    let response = { data: [] }
    try {
        response = await axios.get(URL.bff.adfTrackingApp)
    } catch (error: any) {
        console.log('Error getting automated delivery of financial (ADF) data from data source: ', error)
    }

    const adfApps = response.data
    return adfApps; 

}

function convertArrayToAdfApplications(rawData: any[]): AdfApplication[] {
    if(!Array.isArray(rawData)) {
        console.warn('Raw data is not convertible to type.')
        return [];
    }
        
    return rawData.map(item => ({
        adfId: item.adfId,
        cif: item.cif,
        companyId: item.companyId,
        codatCompanyId: item.codatCompanyId,
        creditSolutionsContact: item.creditSolutionsContact,
        creditSolutionsContactEmail: item.creditSolutionsContactEmail,
        creditSolutionsContactSource: item.creditSolutionsContactSource,
        crmEntityId: item.crmEntityId,
        crmEntityIdOriginal: item.crmEntityIdOriginal,
        dbaName: item.dbaName,
        matchType: item.matchType,
        product: item.product,
        status: item.status,
        teamCode: item.teamCode,
        userEmail: item.userEmail,
        userPhoneNumber: item.userPhoneNumber,
        userFirstName: item.userFirstName,
        userLastName: item.userLastName
    }));
}